import tw from 'twin.macro'

export const ActionDialogActions = tw.div`
  flex
  flex-wrap
  justify-end
  mt-14
  gap-3
`

export const StyledActionDialogError = tw.div`
  text-red-500
  leading-5
`
